export const IONA = {
  brand: "İONA",
  fullBrand: "İONA Güzellik Merkezi",
  footerBrand: "İONA - Ümraniye Güzellik Merkezi",
  logo: "https://customer-assets.emergentagent.com/job_iona-beauty/artifacts/tzpe0iuh_7_C%CC%A7al%C4%B1s%CC%A7ma%20Yu%CC%88zeyi%201%20kopya%205%20%281%29.png",
  phone: "05411894258",
  phoneIntl: "+905411894258",
  whatsapp: "905411894258",
  instagram: "ionaumraniyeguzellik",
  instagramUrl: "https://instagram.com/ionaumraniyeguzellik",
  location: "Ümraniye / İstanbul",
  workingHours: "Pzt - Cmt: 10:00 - 19:00 · Pazar Kapalı",
  siteUrl: "https://ionabeauty.com",
  coords: { lat: 41.0255216, lng: 29.0909033 },
  mapEmbed:
    "https://maps.google.com/maps?q=%C4%B0ona+G%C3%BCzellik+Salonu&ll=41.0255216,29.0909033&z=17&hl=tr&output=embed",
  mapDirections:
    "https://www.google.com/maps/dir/?api=1&destination=41.0255216,29.0909033&destination_place_id=ChIJWWAR68rJyhQRhOrCO5-hi9Y",
};

export const waLink = (msg = "Merhaba, İONA Güzellik Merkezi'nden randevu almak istiyorum.") =>
  `https://wa.me/${IONA.whatsapp}?text=${encodeURIComponent(msg)}`;
